var _rect, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinLight = function SvgPinLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 136,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 80,
    x: 27,
    y: 56,
    fill: "url(#pin_light_svg__a)",
    rx: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_light_svg__b)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#pin_light_svg__c)",
    strokeWidth: 3,
    d: "M27 8h3v60h-3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_light_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#pin_light_svg__e)",
    strokeWidth: 3,
    d: "M27 8h3v60h-3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_light_svg__f)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 37,
    y: 48,
    fill: "url(#pin_light_svg__g)",
    rx: 8.5,
    transform: "rotate(90 37 48)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_light_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 37,
    y: 48,
    fill: "url(#pin_light_svg__i)",
    rx: 8.5,
    transform: "rotate(90 37 48)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_svg__a",
    x1: 28.5,
    x2: 21.055,
    y1: 136,
    y2: 135.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_svg__c",
    x1: 28,
    x2: 28,
    y1: 68.071,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#181B25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#181B25",
    stopOpacity: 0.131
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#96C5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#05DF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_svg__e",
    x1: 28,
    x2: 28,
    y1: 68.071,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#fff",
    stopOpacity: 0.131
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#96C5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#05DF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_svg__g",
    x1: 39.665,
    x2: 58.633,
    y1: 84.512,
    y2: 81.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_svg__i",
    x1: 39.665,
    x2: 58.633,
    y1: 84.512,
    y2: 81.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_light_svg__b",
    width: 8,
    height: 65,
    x: 24.5,
    y: 5.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5539_96704",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_light_svg__d",
    width: 18,
    height: 75,
    x: 19.5,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5539_96704",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_light_svg__f",
    width: 57,
    height: 57,
    x: 0,
    y: 28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2 0 0 0 0 0.921569 0 0 0 0 0.513726 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5539_96704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5539_96704",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_5539_96704",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_light_svg__h",
    width: 33,
    height: 33,
    x: 12,
    y: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5539_96704",
    stdDeviation: 4
  })))));
};
export default SvgPinLight;